import Vue from "vue";
import { Auth } from "aws-amplify";

const moment = require("moment-timezone");

export function process_500_error(error_text) {
  Vue.$router.push({ name: "error500" });
}

export function process_403_error(error_text) {
  Vue.$router.push({ name: "error403" });
}

export function process_404_error(error_text) {
  Vue.$router.push({ name: "error404" });
}

export function process_api_error(message, error_text) {
  console.log(message, error_text);
}

export function getPrefixFromMoment(in_time) {
  switch (in_time.isoWeekday()) {
    case 1:
      return "mon";
      break;
    case 2:
      return "tue";
      break;
    case 3:
      return "wed";
      break;
    case 4:
      return "thu";
      break;
    case 5:
      return "fri";
      break;
    case 6:
      return "sat";
      break;
    case 7:
      return "sun";
      break;
  }
}

//TODO this function is wrong - it doesn't determine store status taking into account real store timezone
export function calculateStoreStatus(store, time) {
  //Needs to be reevaluated
  var in_time = time ? moment(time) : moment();
  var in_time_in_store_tz = moment(in_time);
  var working_time = moment(in_time_in_store_tz);
  var suffix = getPrefixFromMoment(in_time_in_store_tz);
  var prev_day_suffix = getPrefixFromMoment(
    moment(in_time_in_store_tz).add(-1, "day")
  );

  var open_time_that_day = moment(in_time_in_store_tz)
    .startOf("day")
    .add(store["open_time_" + suffix], "minutes");
  var close_time_that_day = moment(in_time_in_store_tz)
    .startOf("day")
    .add(store["close_time_" + suffix], "minutes");
  var open_time_prev_day = moment(in_time_in_store_tz)
    .add(-1, "day")
    .startOf("day")
    .add(store["open_time_" + prev_day_suffix], "minutes");
  var close_time_prev_day = moment(in_time_in_store_tz)
    .add(-1, "day")
    .startOf("day")
    .add(store["close_time_" + prev_day_suffix], "minutes");

  if (open_time_that_day <= working_time) {
    if (close_time_that_day < open_time_that_day) {
      return "Opened";
    } else {
      if (working_time < close_time_that_day) {
        return "Opened";
      }
    }
  } else {
    if (close_time_prev_day < open_time_prev_day) {
      close_time_prev_day = close_time_prev_day.add(1, "day");
      if (working_time < close_time_prev_day) {
        return "Opened";
      }
    }
  }
  return "Closed Now";
}

// check string is not null and empty
// if string is empty or null then return false is return true
export function stringNotEmpty(str) {
  try {
    if (str.trim() !== "null" && str.trim() !== "") {
      return true;
    } else {
      return false;
    }
  } catch (error) {
    return false;
  }
}
// register owner id to onesignal
export function registerUserForNotification() {
  Auth.currentSession()
    .then(data => {
      if (stringNotEmpty(data.idToken.payload.sub)) {
        try {
          var ownerId = data.idToken.payload.sub;
          OneSignal.push(function() {
            OneSignal.setExternalUserId(ownerId);
          });
        } catch (error) {}
      }
      // this.$store.dispatch("setOwnerId", data.idToken.payload.sub);
    })
    .catch(err => console.log("Utils ", err));
}

Vue.prototype.$demo = true;


// WEBPACK FOOTER //
// ./src/utils/utils.js